import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ConfigContext = createContext(null);
export const useConfig = () => useContext(ConfigContext);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/config");
      setConfig(data);
    } catch (e) {}
  };

  useEffect(() => {
    load();
  }, []);

  const save = async (updates) => {
    const { data } = await api.put("/config", updates);
    setConfig(data);
    return data;
  };

  return (
    <ConfigContext.Provider value={{ config, setConfig, save, reload: load }}>
      {children}
    </ConfigContext.Provider>
  );
}
